"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledYearSelectorContainer = exports.StyledYearSelector = exports.StyledTypography = exports.StyledSvgIconContainer = exports.StyledSvgIcon = exports.StyledRow = exports.StyledMonthSelector = exports.StyledDatePickerContainer = exports.StyledDatePickerComponent = exports.StyledCol = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _SvgIcon = _interopRequireDefault(require("../../SvgIcon/index.js"));
var _DatepickerComponent = require("./DateSelector/DatepickerComponent.js");
var _Typography = _interopRequireDefault(require("../../Typography/index.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const StyledDatePickerComponent = exports.StyledDatePickerComponent = (0, _styledComponents.default)(_DatepickerComponent.DatepickerComponent)`
	position: absolute;
`;
const StyledDatePickerContainer = exports.StyledDatePickerContainer = _styledComponents.default.div`
${({
  calenderAlignment = 'left'
}) => (0, _styledComponents.css)`
	position: relative;
	text-align:${calenderAlignment};
`}
`;
const StyledTypography = exports.StyledTypography = (0, _styledComponents.default)(_Typography.default)``;
const StyledMonthSelector = exports.StyledMonthSelector = _styledComponents.default.div`
	width: 100%;
`;
const StyledYearSelector = exports.StyledYearSelector = _styledComponents.default.div`
	width: 100%;
`;
const StyledYearSelectorContainer = exports.StyledYearSelectorContainer = _styledComponents.default.div`
	max-height: 240px;
	overflow: auto;
	scroll-snap-type: y mandatory;
`;
const StyledRow = exports.StyledRow = _styledComponents.default.div`
	display: flex;
	gap: 16px;
	justify-content: flex-start;
	scroll-snap-align: start;
`;
const StyledCol = exports.StyledCol = _styledComponents.default.div`
	${({
  textColor,
  selectedBg,
  selectedColor,
  isSelected,
  disabledDaysColor,
  disabled,
  borderRadius,
  fontFamily,
  fontStyle,
  fontWeight,
  fontSize,
  transformation,
  decoration,
  onHoverTextColor,
  onHoverBgColor,
  isCurrent,
  currentBgColor,
  currentBorderRadius,
  currentBorderWidth,
  currentBorderStyle,
  currentBorderColor,
  currentBoxShadow,
  currentFontFamily,
  currentFontStyle,
  currentFontWeight,
  currentFontSize,
  currentTransformation,
  currentDecoration,
  currentTextColor,
  selectedBorderRadius,
  selectedBorderWidth,
  selectedBorderStyle,
  selectedBorderColor,
  selectedBoxShadow,
  selectedFontFamily,
  selectedFontStyle,
  selectedFontWeight,
  selectedFontSize,
  selectedTransformation,
  selectedDecoration
}) => {
  return (0, _styledComponents.css)`
			padding: 8px;
			width: 5em;
			${StyledTypography} {
				text-align: center;
				display: block;
				padding: 12px 8px;
				${disabled ? `` : `cursor: pointer;`}
				color: ${disabled ? disabledDaysColor : textColor};
				border-radius: ${borderRadius ?? '4px'};
				transition: all 0.3s;
				font-family:${fontFamily};
				font-style:${fontStyle};
				font-weight:${fontWeight};
				font-size:${fontSize}px;
				text-transform:${transformation};
    			text-decoration:${decoration == 'strike_of' ? 'line-through' : decoration == 'underline_overline' ? 'underline overline' : decoration};


				${isSelected ? `
					color: ${selectedColor}!important ;
					background: ${selectedBg} !important;
					font-family:${selectedFontFamily || "Nunito Sans"};
					font-style:${selectedFontStyle};
					font-weight:${selectedFontWeight};
					font-size:${selectedFontSize}px;
					text-transform:${selectedTransformation};
					text-decoration:${selectedDecoration == 'strike_of' ? 'line-through' : selectedDecoration == 'underline_overline' ? 'underline overline' : selectedDecoration};

					${selectedBoxShadow};
					border-width:${selectedBorderWidth}px;
					border-style:${selectedBorderStyle};
					border-color:${selectedBorderColor};
					border-radius: ${selectedBorderRadius ?? 4}px;
				` : ``}

				${isCurrent ? `
					color: ${currentTextColor || textColor} !important;
					background: ${currentBgColor || selectedBg} !important;
					font-family:${currentFontFamily || "Nunito Sans"};
					font-style:${currentFontStyle};
					font-weight:${currentFontWeight};
					font-size:${currentFontSize}px;
					text-transform:${currentTransformation};
					text-decoration:${currentDecoration == 'strike_of' ? 'line-through' : currentDecoration == 'underline_overline' ? 'underline overline' : currentDecoration};

					${currentBoxShadow};
					border-width:${currentBorderWidth}px;
					border-style:${currentBorderStyle};
					border-color:${currentBorderColor};
					border-radius: ${currentBorderRadius ?? 4}px;
				` : ``}

				&:hover {
					${disabled ? `` : `
							color: ${onHoverTextColor};
							background: ${onHoverBgColor};`}
				}
			}
		`;
}}
`;
const StyledSvgIcon = exports.StyledSvgIcon = (0, _styledComponents.default)(_SvgIcon.default)`
	cursor: pointer;
`;
const StyledSvgIconContainer = exports.StyledSvgIconContainer = _styledComponents.default.div`
	display: flex;
	justify-content: flex-start;
`;